import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '@/stores'
import NProgress from 'nprogress'

const routes: RouteRecordRaw[] = [
    {
        path: '/',
        redirect: '/ticket-boards'
    },
    {
        path: '/new_contact_from_salesforce',
        redirect: '/managers/create'
    },
    {
        path: '/tickets/:id',
        redirect: (to) => ({ path: '/ticket-boards', query: { ticket: to.params.id } })
    },

    {
        path: '/organizations',
        component: () => import('@ezio/ui/layouts/DashboardMain.vue'),
        children: [
            {
                path: '',
                name: 'organizations',
                components: {
                    default: () => import('@/pages/organizations/Home.vue'),
                    secondarySidebar: () => import('@/pages/organizations/Nav.vue')
                }
            },
            {
                path: 'create',
                name: 'organization-create',
                components: {
                    default: () => import('@/pages/organizations/CreateEdit.vue'),
                    secondarySidebar: () => import('@/pages/organizations/Nav.vue')
                }
            },
            {
                path: ':id',
                components: {
                    default: () => import('@ezio/ui/layouts/RouterViewWrapper.vue'),
                    secondarySidebar: () => import('@/pages/organizations/Nav.vue')
                },
                children: [
                    {
                        path: '',
                        name: 'organization',
                        component: () => import('@/pages/organizations/Show.vue')
                    },
                    {
                        path: 'edit',
                        name: 'organization-edit',
                        component: () => import('@/pages/organizations/CreateEdit.vue')
                    }
                ]
            }
        ]
    },

    {
        path: '/agencies',
        component: () => import('@ezio/ui/layouts/DashboardMain.vue'),
        children: [
            {
                path: '',
                name: 'agencies',
                components: {
                    default: () => import('@/pages/agencies/Home.vue'),
                    secondarySidebar: () => import('@/pages/agencies/Nav.vue')
                }
            },
            {
                path: ':id',
                components: {
                    default: () => import('@ezio/ui/layouts/RouterViewWrapper.vue'),
                    secondarySidebar: () => import('@/pages/agencies/Nav.vue')
                },
                children: [
                    {
                        path: '',
                        name: 'agency',
                        component: () => import('@/pages/agencies/Show.vue')
                    },
                    {
                        path: 'users/:userId',
                        name: 'agency-user',
                        component: () => import('@/pages/agencies/users/Show.vue')
                    }
                ]
            }
        ]
    },

    {
        path: '/networks',
        component: () => import('@ezio/ui/layouts/DashboardMain.vue'),
        children: [
            {
                path: '',
                name: 'networks',
                components: {
                    default: () => import('@/pages/networks/Home.vue'),
                    secondarySidebar: () => import('@/pages/networks/Nav.vue')
                }
            },
            {
                path: 'create',
                name: 'network-create',
                components: {
                    default: () => import('@/pages/networks/CreateEdit.vue'),
                    secondarySidebar: () => import('@/pages/networks/Nav.vue')
                }
            },
            {
                path: ':id',
                components: {
                    default: () => import('@ezio/ui/layouts/RouterViewWrapper.vue'),
                    secondarySidebar: () => import('@/pages/networks/Nav.vue')
                },
                children: [
                    {
                        path: '',
                        name: 'network',
                        component: () => import('@/pages/networks/Show.vue')
                    },
                    {
                        path: 'edit',
                        name: 'network-edit',
                        component: () => import('@/pages/networks/CreateEdit.vue')
                    }
                ]
            }
        ]
    },
    {
        path: '/bank',
        component: () => import('@ezio/ui/layouts/DashboardMain.vue'),
        children: [
            {
                path: '',
                redirect: '/bank/cards'
            },
            {
                path: 'cards',
                name: 'cards',
                components: {
                    default: () => import('@/pages/cards/Home.vue'),
                    secondarySidebar: () => import('@/pages/operations/Nav.vue')
                }
            },
            {
                path: 'cards/:id',
                components: {
                    default: () => import('@ezio/ui/layouts/RouterViewWrapper.vue'),
                    secondarySidebar: () => import('@/pages/operations/Nav.vue')
                },
                children: [
                    {
                        path: '',
                        name: 'card',
                        component: () => import('@/pages/cards/Show.vue')
                    }
                ]
            },
            {
                path: 'operations',
                name: 'operations',
                components: {
                    default: () => import('@/pages/operations/Home.vue'),
                    secondarySidebar: () => import('@/pages/operations/Nav.vue')
                }
            },
            {
                path: 'sdde',
                children: [
                    {
                        path: '',
                        name: 'sdde-index',
                        components: {
                            default: () => import('@/pages/operations/sdde/Index.vue'),
                            secondarySidebar: () => import('@/pages/operations/Nav.vue')
                        }
                    },
                    {
                        path: ':sddeId',
                        name: 'sdde-show',
                        components: {
                            default: () => import('@/pages/operations/sdde/Show.vue'),
                            secondarySidebar: () => import('@/pages/operations/Nav.vue')
                        }
                    }
                ]
            },
            {
                path: 'sctr',
                children: [
                    {
                        path: '',
                        name: 'sctr-index',
                        components: {
                            default: () => import('@/pages/operations/sctr/Index.vue'),
                            secondarySidebar: () => import('@/pages/operations/Nav.vue')
                        }
                    },
                    {
                        path: ':sctrId',
                        name: 'sctr-show',
                        components: {
                            default: () => import('@/pages/operations/sctr/Show.vue'),
                            secondarySidebar: () => import('@/pages/operations/Nav.vue')
                        }
                    }
                ]
            },
            {
                path: 'scte',
                children: [
                    {
                        path: '',
                        name: 'scte-index',
                        components: {
                            default: () => import('@/pages/operations/scte/Index.vue'),
                            secondarySidebar: () => import('@/pages/operations/Nav.vue')
                        }
                    },
                    {
                        path: ':scteId',
                        name: 'scte-show',
                        components: {
                            default: () => import('@/pages/operations/scte/Show.vue'),
                            secondarySidebar: () => import('@/pages/operations/Nav.vue')
                        }
                    }
                ]
            },
            {
                path: 'card-transactions',
                children: [
                    {
                        path: '',
                        name: 'card-transactions-index',
                        components: {
                            default: () => import('@/pages/operations/card-transaction/Index.vue'),
                            secondarySidebar: () => import('@/pages/operations/Nav.vue')
                        }
                    },
                    {
                        path: ':transactionId',
                        name: 'card-transactions-show',
                        components: {
                            default: () => import('@/pages/operations/card-transaction/Show.vue'),
                            secondarySidebar: () => import('@/pages/operations/Nav.vue')
                        }
                    }
                ]
            }
        ]
    },

    {
        path: '/ticket-boards',
        component: () => import('@ezio/ui/layouts/DashboardMain.vue'),
        children: [
            {
                path: '',
                name: 'ticket-boards',
                components: {
                    default: () => import('@/pages/ticket-boards/Home.vue'),
                    secondarySidebar: () => import('@/pages/ticket-boards/Nav.vue')
                }
            },
            {
                path: ':id',
                name: 'ticket-board',
                components: {
                    default: () => import('@/pages/ticket-boards/Board.vue'),
                    secondarySidebar: () => import('@/pages/ticket-boards/Nav.vue')
                }
            }
        ]
    },

    {
        path: '/clients/:id',
        component: () => import('@ezio/ui/layouts/DashboardMain.vue'),
        children: [
            {
                path: '',
                name: 'client',
                component: () => import('@/pages/clients/Show.vue'),
                meta: { sidebar: false }
            }
        ]
    },

    {
        path: '/employees/:id',
        component: () => import('@ezio/ui/layouts/DashboardMain.vue'),
        children: [
            {
                path: '',
                name: 'employee',
                component: () => import('@/pages/employees/Show.vue'),
                meta: { sidebar: false }
            }
        ]
    },

    {
        path: '/managers/:id',
        component: () => import('@ezio/ui/layouts/DashboardMain.vue'),
        children: [
            {
                path: '',
                name: 'manager',
                component: () => import('@/pages/managers/Show.vue'),
                meta: { sidebar: false }
            }
        ]
    },

    {
        path: '/users',
        component: () => import('@ezio/ui/layouts/DashboardMain.vue'),
        children: [
            {
                path: '',
                name: 'users',
                component: () => import('@/pages/users/Index.vue'),
                meta: {
                    sidebar: false
                }
            }
        ]
    },

    {
        path: '/sign-in',
        name: 'signIn',
        component: () => import('@/pages/auth/SignIn.vue'),
        meta: {
            layout: 'Centered',
            autorisationLevel: 0
        }
    }
]

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes
})

router.beforeEach(async (to, from, next) => {
    if (!NProgress.isStarted()) {
        NProgress.start()
    }

    const authStore = useAuthStore()

    if (useAuthStore().isLoggedIn && !authStore.user) {
        await authStore.fetch()
    }

    const requiredAutorisationLevel = (to.meta.autorisationLevel as number) ?? 1
    const userAutorisationLevel = useAuthStore().autorisationLevel

    if (userAutorisationLevel < requiredAutorisationLevel) {
        next('/sign-in?redirect=' + to.fullPath)
    } else {
        next()
    }
})

router.afterEach(() => {
    NProgress.done()
})

export default router
